import React, { useState, useRef } from "react";
import { Card, Form, Row, Col, InputGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useUnsavedChangesWarning from "../../shared/hooks/useUnsavedChangesWarning";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";
import MobileOtp from "../../onboarding/MobileOtp";
import EmailOtp from "../../onboarding/EmailOtp";
import AddressForm from "../../shared/AddressForm";
import UserSearch from "./UserSearch";
import userService from "../../services/user.service";
import localdataService from "../../services/localdata.service";
import { LinkContainer } from "react-router-bootstrap";

const NewUser = ({ redirectTo, title }) => {
  const [setLoaderActive, toast, myConfirm] = useContext(AppContext);
  document.title = "Patient Registration";
  const [newForm, setNewForm] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emergency, setEmergency] = useState(false);
  const formRef = useRef({});

  const navigate = useNavigate();
  useUnsavedChangesWarning(isDirty);
  // usePrompt("Hello from usePrompt -- Are you sure you want to leave?", isDirty);

  async function handleSubmit(e) {
    e.preventDefault();
    const dataBody = {
      user: {
        first_name: formRef.current["firstName"].value,
        last_name: formRef.current["lastName"].value,
        gender: formRef.current["gender"].value,
        marital_status: formRef.current["maritialStatus"].value,
        dob: formRef.current["dob"].value,
        ...formRef.current["mobile"].value,
        ...formRef.current["email"].value,
        address: formRef.current["address"].value,
      },
    };
    if (emergency)
      dataBody["emergency"] = {
        ep_name: formRef.current["ep_name"].value,
        relation: formRef.current["relation"].value,
        ...formRef.current["emergency_mobile"].value,
        ...formRef.current["emergency_email"].value,
        address: formRef.current["emergency_address"].value,
      };
    console.log(dataBody);
    const form = e.currentTarget;
    let error = false;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setValidated(true);

    if (
      (emergency &&
        dataBody.user.mobile === "" &&
        dataBody.emergency.mobile === "") ||
      (!emergency && dataBody.user.mobile === "")
    ) {
      error = true;
      toast.error(
        "Please provide at least one mobile number: your primary contact number and/or an emergency contact number."
      );
    }
    if (error) return false;
    setLoaderActive(true);

    const response = await userService.addUser(dataBody);
    console.log(response);
    setLoaderActive(false);
    if (response) {
      if (response.new) {
        toast.success("New patient added.");
        navigate(`/${redirectTo}/${response.user.kapid_user_id}`);
      } else {
        if (
          await myConfirm(
            `An existing user '${response.user.full_name}-${response.user.kapid_user_id}' with mobile number '${dataBody.user.mobile}'  already exists. To proceed with this user, please click 'Yes.' If you'd like to use a different mobile number, click 'No.'`
          )
        ) {
          navigate(`/${redirectTo}/${response.user.kapid_user_id}`);
        }
      }
    }
  }
  const searchRef = useRef(null);
  const handleChange = (s) => {
    localdataService.setRecentKapidUserSearch(s, redirectTo.toLowerCase());
    // console.log(s);
    s.id === 0 ? setNewForm(true) : navigate(`/${redirectTo}/${s.id}`);
  };
  const recentSearch = localdataService.getRecentKapidUserSearch(redirectTo);

  return (
    <>
      <h1 className="text-center">{title} Search & Registration</h1>
      <InputGroup className="mb-3">
        <UserSearch
          onChange={handleChange}
          notFoundData={{ id: 0, label: "Add New" }}
          // alwaysShowNotFoundData={true}
          //clearAfterChange={false}
          ref={searchRef}
        />
        <Button
          className="bg-new-deep"
          variant="light"
          onClick={() => setNewForm(!newForm)}
          //onClick={handleClick}
        >
          Add New
        </Button>
      </InputGroup>
      {recentSearch && recentSearch.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h4>Recent Searches:</h4>
          <div className="d-flex flex-wrap">
            {recentSearch.map((item, index) => (
              <div key={index} className="p-2">
                <LinkContainer to={`/${redirectTo}/${item.kapid_id}`}>
                  <button className="btn btn-outline-secondary">
                    {item.full_name} - {item.kapid_id}
                  </button>
                </LinkContainer>
              </div>
            ))}
          </div>
        </div>
      )}
      {newForm && (
        <>
          <Form
            noValidate
            validated={validated}
            onChange={() => setIsDirty(true)}
            onSubmit={handleSubmit}
          >
            <Card className="mb-3 bg-new">
              <Card.Header as="h5">Demographic Information</Card.Header>
              <Card.Body>
                <Row xs={1} sm={1} md={1} lg={2}>
                  <Col>
                    <fieldset>
                      <legend className="border-bottom border-success">
                        Personal Information
                      </legend>

                      <Row xs={1} sm={1} md={2}>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="First Name"
                              required
                              name="firstName"
                              ref={(el) => (formRef.current["firstName"] = el)}
                              // value={formInputData.firstName}
                              // onChange={handleInputChange}
                              minLength="3"
                              maxLength="50"
                              autoFocus
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Last Name"
                              required
                              name="lastName"
                              ref={(el) => (formRef.current["lastName"] = el)}
                              // value={formInputData.firstName}
                              // onChange={handleInputChange}
                              minLength="3"
                              maxLength="50"
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Gender</Form.Label>
                            <Form.Select
                              aria-label="Gender"
                              required
                              name="gender"
                              ref={(el) => (formRef.current["gender"] = el)}
                              // value={formInputData.state}
                              // onChange={handleInputChange}
                            >
                              <option value="">Select</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Transgender">Transgender</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Marital Status</Form.Label>
                            <Form.Select
                              aria-label="Marital Status"
                              required
                              name="maritialStatus"
                              ref={(el) =>
                                (formRef.current["maritialStatus"] = el)
                              }
                              // value={formInputData.state}
                              // onChange={handleInputChange}
                            >
                              <option value="">Select</option>
                              <option value="Married">Married</option>
                              <option value="Unmarried">Unmarried</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Date of Birth</Form.Label>
                            <Form.Control
                              type="date"
                              required
                              name="dob"
                              ref={(el) => (formRef.current["dob"] = el)}
                              // value={formInputData.firstName}
                              // onChange={handleInputChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </fieldset>
                  </Col>
                  <Col>
                    <fieldset>
                      <legend className="border-bottom border-success">
                        Contact Information
                      </legend>
                      <Row xs={1} sm={1}>
                        <Col>
                          <MobileOtp
                            required={false}
                            ref={(el) => (formRef.current["mobile"] = el)}
                          />
                        </Col>
                        <Col>
                          <EmailOtp
                            required={false}
                            ref={(el) => (formRef.current["email"] = el)}
                          />
                        </Col>
                      </Row>
                      <AddressForm
                        ref={(el) => (formRef.current["address"] = el)}
                      />
                    </fieldset>
                  </Col>
                </Row>
                <Form.Check
                  type="switch"
                  id="emergency-switch"
                  label="Emergency Contact"
                  checked={emergency}
                  onChange={({ target }) => setEmergency(target.checked)}
                />
                {emergency && (
                  <Row xs={1} sm={1} md={1} lg={2}>
                    <Col>
                      <fieldset>
                        <legend className="border-bottom border-success">
                          Emergency Contact Person
                        </legend>
                        <Row xs={1}>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Contact Person Name</Form.Label>
                              <Form.Control
                                name="emergencyPerson"
                                type="text"
                                placeholder="Contact Person Name"
                                required
                                autoFocus
                                ref={(el) => (formRef.current["ep_name"] = el)}
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Label>Relation with Person</Form.Label>
                              <Form.Select
                                aria-label="Relation with Patient"
                                required
                                name="relationWithPatient"
                                ref={(el) => (formRef.current["relation"] = el)}
                              >
                                <option value="">Select</option>
                                <option value="father">Father</option>
                                <option value="mother">Mother</option>
                                <option value="brother">Brother</option>
                                <option value="sister">Sister</option>
                                <option value="spouse">Spouse</option>
                                <option value="cousin">Cousin</option>
                                <option value="friend">Friend</option>
                                <option value="other">Other</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                      </fieldset>
                    </Col>

                    <Col>
                      <fieldset>
                        <legend className="border-bottom border-success">
                          Emergency Contact Information
                        </legend>
                        <Row xs={1} sm={1}>
                          <Col>
                            <MobileOtp
                              name="emergency_mobile"
                              required={false}
                              unique={false}
                              ref={(el) =>
                                (formRef.current["emergency_mobile"] = el)
                              }
                            />
                          </Col>
                          <Col>
                            <EmailOtp
                              name="emergency_email"
                              required={false}
                              unique={false}
                              ref={(el) =>
                                (formRef.current["emergency_email"] = el)
                              }
                            />
                          </Col>
                        </Row>
                        <AddressForm
                          prefilled={formRef.current["address"].value}
                          ref={(el) =>
                            (formRef.current["emergency_address"] = el)
                          }
                        />
                      </fieldset>
                    </Col>
                  </Row>
                )}
              </Card.Body>
              <div className="card-footer d-flex justify-content-between">
                <Button type="reset" variant="dark">
                  Reset
                </Button>
                <Button type="submit" variant="light" className="bg-new-deep">
                  Save
                </Button>
              </div>
            </Card>
          </Form>
        </>
      )}
    </>
  );
};

export default NewUser;
